export interface PageConfig {
  title: string;
  route: string;
  activeRoutes: string[];
}

export interface SettingConfig {
  title: string;
  route: string;
}

export const pages: PageConfig[] = [
  {
    title: 'Costs Optimizer',
    route: 'optimizer',
    activeRoutes: ['optimizer', 'optimizer-list', 'optimizer-costs-results', 'summarize'],
  },
  {
    title: 'Payment calender',
    route: 'calendar',
    activeRoutes: ['calendar'],
  },
  {
    title: 'Forecasting',
    route: 'forecasting',
    activeRoutes: ['forecasting'],
  },
];

export const settings: SettingConfig[] = [
  {
    title: 'Logout',
    route: 'logout',
  },
];

export const isRouteActive = (activeRoutes: string[], pathname: string): boolean => {
  const currentRoute = pathname.split('/')[1] || 'optimizer';
  return activeRoutes.includes(currentRoute);
};
